let productGroupingHelper = (function ($) {
	class ProductsGroupingResult {
		constructor(description, note, noteTooltip) {
			this.description = description;
			this.note = note;
			this.noteTooltip = noteTooltip;
		}

		getDescription() {
			return this.description;
		}

		getNote() {
			return this.note;
		}

		getNoteTooltip() {
			return this.noteTooltip;
		}

		hasTooltip() {
			return this.note !== null;
		}
	}

	/**
	 * @param {{
	 *     id: string,
	 *     code: string,
	 *     name: string,
	 *     nameSupplement: string,
	 *     registeredName: string,
	 *     nameWithNameSupplement: string
	 * }[]} products
	 * @returns {ProductsGroupingResult}
	 */
	let createProductGroupingResult = function (products) {
		const MAX_PRODUCTS_IN_TOOLTIP_NOTE = 20;
		const MAX_BRANDS_IN_DESCRIPTION = 3;
		var resolveName = function (product) {
			return product.registeredName || product.name;
		};

		if (products.length === 0) {
			return new ProductsGroupingResult('-', null, null);
		}

		if (products.length === 1) {
			return new ProductsGroupingResult(resolveName(products[0]) + ' ' + products[0].nameSupplement, null, null);
		}

		let brands = [];
		let fullProductNames = [];
		for (const product of products) {
			if (brands.indexOf(resolveName(product)) === -1) {
				brands.push(resolveName(product));
			}

			fullProductNames.push(resolveName(product) + ' ' + product.nameSupplement);
		}

		brands.sort();
		fullProductNames.sort();

		let noteTooltip =
			fullProductNames.slice(0, 20).join(', ') + (fullProductNames.length > MAX_PRODUCTS_IN_TOOLTIP_NOTE ? '…' : '');

		if (brands.length === 1) {
			return new ProductsGroupingResult(resolveName(products[0]), products.length + ' balení', noteTooltip);
		}

		let description = brands.slice(0, 3).join(', ') + (brands.length > MAX_BRANDS_IN_DESCRIPTION ? '…' : '');

		if (brands.length < 5) {
			return new ProductsGroupingResult(
				description,
				'celkem ' + brands.length + ' brandy / ' + products.length + ' balení',
				noteTooltip
			);
		}

		return new ProductsGroupingResult(
			description,
			'celkem ' + brands.length + ' brandů / ' + products.length + ' balení',
			noteTooltip
		);
	};

	return {
		createProductGroupingResult: createProductGroupingResult,
	};
})(jQuery);

export { productGroupingHelper };
